export default __webpack_public_path__ + "static/media/2018-Ford-Focus-RS-Hatch-Race-Red.5cb860ae.png";